import { TableProps } from 'antd/lib/table';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/SalesAttributionDrilldownChart';
import { renderTitle } from 'utils/getSalesAttributionColumns';
import { formatNumWithKMBAlt } from 'utils/helperMethods';

export const bumpReportExportTableParser = (
    columns: string[],
    rawData: string[][],
    decimalForNonPercentage: number,
) => {
    const resultColumns: TableProps<any>['columns'] = columns.map((item: string, index: number) => ({
        title: renderTitle(item, undefined, undefined, 'text-purpleFont !font-bold', graphXAxisLabelFontSize),
        dataIndex: `col${index}`,
        width: 140,
        key: `col${index}`,
        align: 'center',
        fixed: index === 0 ? 'left' : false,
        render(value) {
            return (
                <div className="font-xs">
                    {isNaN(value)
                        ? value
                        : formatNumWithKMBAlt(value, decimalForNonPercentage, decimalForNonPercentage)}
                </div>
            );
        },
    }));

    const data = rawData.map((row: string[], rowIndex: number) => {
        const transformedRow: { key: string } & Record<string, string> = { key: `${rowIndex}` };
        row.forEach((value, colIndex) => {
            transformedRow[`col${colIndex}`] = value;
        });
        return transformedRow;
    });
    return { columns: resultColumns, rowsData: data };
};
